const DEBUG_QUERY_PARAM = "debug";

const DISABLED_DEBUG_VALUES = new Set(["0", "false", "no", "off"]);
const GENERIC_DEBUG_VALUES = new Set(["", "1", "true", "yes", "on"]);

const getNormalizedDebugValue = (searchParams: URLSearchParams) =>
  searchParams.get(DEBUG_QUERY_PARAM)?.trim().toLowerCase() ?? null;

export const isDebugQueryEnabled = (searchParams: URLSearchParams) => {
  const value = getNormalizedDebugValue(searchParams);
  return value !== null && !DISABLED_DEBUG_VALUES.has(value);
};

export const getDebugQueryMode = (
  searchParams: URLSearchParams,
): string | null => {
  const value = getNormalizedDebugValue(searchParams);
  if (
    value === null ||
    DISABLED_DEBUG_VALUES.has(value) ||
    GENERIC_DEBUG_VALUES.has(value)
  ) {
    return null;
  }
  return value;
};

export const isDebugQueryMode = (searchParams: URLSearchParams, mode: string) =>
  getDebugQueryMode(searchParams) === mode.trim().toLowerCase();
